import { render, staticRenderFns } from "./ModulForm.vue?vue&type=template&id=63df9894"
import script from "./ModulForm.vue?vue&type=script&lang=js"
export * from "./ModulForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports